module.exports = __webpack_public_path__ + "img/PPUsuario-Portal.c7d0b16c.png";